import dotenv from "dotenv";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/global.css";
import App from "./App";

dotenv.config();

ReactDOM.render(
    //TODO: HABILITAR StrictMode
    // <React.StrictMode>
    <App />,
    // </React.StrictMode>,
    document.getElementById("root")
);
